import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ReleaseStatus } from 'services/store/distribution/types';

type PropsType = {
  releaseStatus: string;
};

const ReleaseStatusChip = ({ releaseStatus }: PropsType) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const statusColor = useMemo(() => {
    if (releaseStatus === ReleaseStatus.RELEASED) {
      return theme.palette.primary.main;
    }
    if (releaseStatus === ReleaseStatus.PENDING) {
      return theme.palette.warning.main;
    }
    if (releaseStatus === ReleaseStatus.DRAFT) {
      return theme.palette.info.main;
    }
    return theme.palette.error.main;
  }, [releaseStatus, theme]);

  const statusName = useMemo(() => {
    if (releaseStatus === ReleaseStatus.RELEASED) {
      return t('distribution:releaseStatus:released');
    }
    if (releaseStatus === ReleaseStatus.PENDING) {
      return t('distribution:releaseStatus:pending');
    }
    if (releaseStatus === ReleaseStatus.DRAFT) {
      return t('distribution:releaseStatus:draft');
    }
    return t('distribution:releaseStatus:declined');
  }, [releaseStatus, t]);

  return (
    <Chip
      sx={{
        border: 1,
        fontSize: 12,
        fontWeight: 'bold',
        background: theme.palette.grey[800],
        borderRadius: theme.spacing(0.5),
        color: statusColor,
        borderColor: statusColor,
      }}
      label={statusName}
    />
  );
};

export default ReleaseStatusChip;
